import {Point} from '@yandex-taxi/js-integration-api'
import {useTariff, useTariffsState} from '@yandex-taxi/react-integration-api'
import {useEffect, useState} from 'react'

import {MAX_POINTS_AMOUNT} from './consts'
import {useSetBoundsSettings} from './map-bounds'

export const useMapBounds = (tab: string): [Point[], (newBounds: Point[]) => void] => {
  const setBoundsSettings = useSetBoundsSettings()
  const [bounds, setBounds] = useState<Point[]>()

  useEffect(() => {
    setBoundsSettings({shouldBounds: true})
  }, [tab, setBoundsSettings])

  return [bounds, setBounds]
}

export const useMaxRoutePoints = () => {
  const [{value: tariffClass}] = useTariff()
  const {data} = useTariffsState()
  const maxRoutePoints = data?.find(item => item.class === tariffClass)?.max_route_points_count || MAX_POINTS_AMOUNT
  return maxRoutePoints
}
